export const DEFAULT_SPRING_TYPE = {
    type: 'spring',
    damping: 18
};
